export enum PRODUCT_SUBCATEGORIES_ITEM_COUNT {
  MOBILE = 4,
  DESKTOP = 6,
}
